module.exports = __webpack_public_path__ + "static/media/tennis.13754222.svg";